/**
 * Vitalimes Custom HTML Theme Client Scripts
 */

document.addEventListener("DOMContentLoaded", function () {
  
  // ==========================================
  // 0. GLOBAL BUY NOW REDIRECTION
  // ==========================================
  document.querySelectorAll('.buy-now-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const form = btn.closest('form');
      if (form) {
        let returnInput = form.querySelector('input[name="return_to"]');
        if (!returnInput) {
          returnInput = document.createElement('input');
          returnInput.type = 'hidden';
          returnInput.name = 'return_to';
          returnInput.value = '/checkout';
          form.appendChild(returnInput);
        } else {
          returnInput.value = '/checkout';
        }
        form.submit();
      }
    });
  });
  
  // ==========================================
  // 1. MOBILE DRAWER NAVIGATION
  // ==========================================
  const toggleBtn = document.getElementById("mobile-menu-toggle");
  const drawer = document.getElementById("mobile-menu-drawer");
  if (toggleBtn && drawer) {
    toggleBtn.addEventListener("click", function () {
      drawer.classList.toggle("hidden");
    });
  }

  // ==========================================
  // 2. HERO CAROUSEL SLIDER
  // ==========================================
  const slides = document.querySelectorAll(".hero-slide");
  const dots = document.querySelectorAll(".hero-dot-btn");
  const prevBtn = document.getElementById("hero-prev-btn");
  const nextBtn = document.getElementById("hero-next-btn");
  let currentSlide = 0;
  let slideInterval;

  function showSlide(idx) {
    if (slides.length === 0) return;
    
    // Clamp index
    if (idx >= slides.length) idx = 0;
    if (idx < 0) idx = slides.length - 1;

    slides.forEach((slide) => slide.classList.remove("active"));
    dots.forEach((dot) => {
      dot.classList.remove("w-8", "bg-pine-900");
      dot.classList.add("w-2.5", "bg-pine-900/35");
    });

    slides[idx].classList.add("active");
    if (dots[idx]) {
      dots[idx].classList.remove("w-2.5", "bg-pine-900/35");
      dots[idx].classList.add("w-8", "bg-pine-900");
    }
    
    currentSlide = idx;
    
    // Restart dynamic timer
    startAutoplay();
  }

  function startAutoplay() {
    stopAutoplay();
    // 10 seconds for the first slide (interactive tree), 5 seconds for banner slides
    const delay = (currentSlide === 0) ? 10000 : 5000;
    slideInterval = setTimeout(() => {
      showSlide(currentSlide + 1);
    }, delay);
  }

  function stopAutoplay() {
    if (slideInterval) clearTimeout(slideInterval);
  }

  if (prevBtn && nextBtn) {
    prevBtn.addEventListener("click", () => {
      showSlide(currentSlide - 1);
    });
    nextBtn.addEventListener("click", () => {
      showSlide(currentSlide + 1);
    });
    dots.forEach((dot) => {
      dot.addEventListener("click", () => {
        const target = parseInt(dot.getAttribute("data-slide-to"));
        showSlide(target);
      });
    });
    startAutoplay();
  }

  // ==========================================
  // 3. INTERACTIVE TREE NODES POPUP (DESKTOP)
  // ==========================================
  const treeNodes = document.querySelectorAll(".tree-tag-node");
  const popup = document.getElementById("tree-product-popup");
  const closePopup = document.getElementById("close-popup-btn");
  const popupImg = document.getElementById("popup-img");
  const popupTitle = document.getElementById("popup-title");
  const popupSub = document.getElementById("popup-sub");
  const popupPrice = document.getElementById("popup-price");
  const popupDesc = document.getElementById("popup-desc");
  const popupBuy = document.getElementById("popup-buy-link");
  const popupDetails = document.getElementById("popup-details-link");

  if (treeNodes.length > 0 && popup) {
    treeNodes.forEach((node) => {
      node.addEventListener("click", function (e) {
        e.stopPropagation();
        const nodeRect = node.getBoundingClientRect();
        const container = document.getElementById("hero-slider-section");
        if (!container) return;
        const containerRect = container.getBoundingClientRect();
        
        // Extract data attributes
        const name = node.getAttribute("data-name");
        const sub = node.getAttribute("data-sub");
        const price = node.getAttribute("data-price");
        const desc = node.getAttribute("data-desc");
        const img = node.getAttribute("data-img");
        const slug = node.getAttribute("data-slug");
        const variantId = node.getAttribute("data-variant-id");

        // Set popup contents
        popupImg.src = img;
        popupTitle.textContent = name;
        popupSub.textContent = sub;
        popupPrice.textContent = "₹" + price.split(".")[0];
        popupDesc.textContent = desc;
        
        if (variantId) {
          popupBuy.href = "#";
          popupBuy.setAttribute("data-variant-id", variantId);
        } else {
          popupBuy.href = "/products/" + slug;
          popupBuy.removeAttribute("data-variant-id");
        }
        popupDetails.href = "/products/" + slug;

        // Exact pixel center coordinates of the clicked tag relative to the slider container
        const nodeCenterX = nodeRect.left - containerRect.left + (nodeRect.width / 2);
        const nodeCenterY = nodeRect.top - containerRect.top + (nodeRect.height / 2);
        
        let posX = nodeCenterX - 160; // center popup horizontally (320px width)
        let posY = nodeCenterY + 30;  // position popup below tag center
        
        const containerWidth = containerRect.width;
        const containerHeight = containerRect.height;
        
        // Boundary checks to keep it inside the slider bounds
        if (posX < 15) posX = 15;
        if (posX + 320 > containerWidth) posX = containerWidth - 335;
        
        // If it overlaps the bottom of the slider area, show it above the tag instead
        if (posY + 230 > containerHeight) {
          posY = nodeCenterY - 260;
        }
        if (posY < 15) posY = 15;

        popup.style.left = posX + "px";
        popup.style.top = posY + "px";
        popup.classList.remove("hidden");
      });
    });

    if (closePopup) {
      closePopup.addEventListener("click", function (e) {
        e.stopPropagation();
        popup.classList.add("hidden");
      });
    }

    document.addEventListener("click", function (e) {
      if (popup && !popup.contains(e.target)) {
        popup.classList.add("hidden");
      }
    });

    if (popupBuy) {
      popupBuy.addEventListener("click", function (e) {
        const variantId = popupBuy.getAttribute("data-variant-id");
        if (variantId) {
          e.preventDefault();
          e.stopPropagation();
          
          const originalHtml = popupBuy.innerHTML;
          popupBuy.innerHTML = "Adding...";
          popupBuy.style.pointerEvents = "none";

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          })
          .then(async (response) => {
            if (response.ok) {
              await refreshCartDrawer();
              openCartDrawer();
              popup.classList.add("hidden");
            } else {
              console.error("Failed to add popup product to cart.");
            }
          })
          .catch((err) => {
            console.error("Error adding popup product to cart:", err);
          })
          .finally(() => {
            popupBuy.innerHTML = originalHtml;
            popupBuy.style.pointerEvents = "auto";
          });
        }
      });
    }
  }

  // ==========================================
  // 4. MILESTONES TIMELINE TABS
  // ==========================================
  const milestoneBtns = document.querySelectorAll(".timeline-tab-btn");
  const milestoneCards = document.querySelectorAll(".timeline-card");
  if (milestoneBtns.length > 0) {
    milestoneBtns.forEach((btn) => {
      btn.addEventListener("click", function () {
        const targetYear = btn.getAttribute("data-year");
        
        milestoneBtns.forEach((b) => {
          b.classList.remove("bg-[#15803D]", "text-white", "shadow-md");
          b.classList.add("text-[#052E16]", "hover:bg-[#15803D]/10");
        });
        
        btn.classList.remove("text-[#052E16]", "hover:bg-[#15803D]/10");
        btn.classList.add("bg-[#15803D]", "text-white", "shadow-md");

        milestoneCards.forEach((card) => {
          if (card.getAttribute("data-card-year") === targetYear) {
            card.classList.remove("hidden");
          } else {
            card.classList.add("hidden");
          }
        });
      });
    });
  }

  // ==========================================
  // 5. IMPACT NUMBERS ANIMATION
  // ==========================================
  const counters = document.querySelectorAll(".animate-number");
  if (counters.length > 0) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const counter = entry.target;
          const target = parseInt(counter.getAttribute("data-target"));
          const suffix = counter.getAttribute("data-suffix") || "";
          let count = 0;
          const duration = 2000; // 2 seconds
          const stepTime = Math.max(Math.floor(duration / target), 15);
          
          const timer = setInterval(() => {
            count += Math.ceil(target / (duration / stepTime));
            if (count >= target) {
              counter.textContent = target + suffix;
              clearInterval(timer);
            } else {
              counter.textContent = count + suffix;
            }
          }, stepTime);
          
          observer.unobserve(counter);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach((c) => observer.observe(c));
  }

  // ==========================================
  // 6. RECIPES CAROUSEL TABS
  // ==========================================
  function setupRecipeTabs(tabSelector, cardSelector) {
    const recipeTabs = document.querySelectorAll(tabSelector);
    const recipeCards = document.querySelectorAll(cardSelector);
    if (recipeTabs.length > 0) {
      recipeTabs.forEach((tab) => {
        tab.addEventListener("click", function () {
          const idx = tab.getAttribute("data-recipe");
          
          recipeTabs.forEach((t) => {
            t.classList.remove("text-pine-900", "border-emerald-600");
            t.classList.add("text-pine-900/50", "border-transparent");
          });
          
          tab.classList.remove("text-pine-900/50", "border-transparent");
          tab.classList.add("text-pine-900", "border-emerald-600");

          recipeCards.forEach((card) => {
            if (card.getAttribute("data-recipe-index") === idx) {
              card.classList.remove("hidden");
            } else {
              card.classList.add("hidden");
            }
          });
        });
      });
    }
  }

  setupRecipeTabs(".recipe-tab-btn", ".recipe-card-item");
  setupRecipeTabs(".recipe-tab-btn-bl", ".recipe-card-item-bl");

  // ==========================================
  // 7. FAQS ACCORDION TOGGLES
  // ==========================================
  const faqToggles = document.querySelectorAll(".faq-toggle-btn");
  if (faqToggles.length > 0) {
    faqToggles.forEach((btn) => {
      btn.addEventListener("click", function () {
        const item = btn.closest(".faq-item");
        const pane = item.querySelector(".faq-answer-pane");
        const indicator = btn.querySelector(".faq-icon-indicator");
        const plus = btn.querySelector(".faq-plus-icon");

        const isOpen = pane.style.maxHeight && pane.style.maxHeight !== "0px";

        // Close all other panels
        document.querySelectorAll(".faq-answer-pane").forEach((p) => {
          p.style.maxHeight = "0px";
        });
        document.querySelectorAll(".faq-plus-icon").forEach((pl) => {
          pl.textContent = "+";
        });
        document.querySelectorAll(".faq-icon-indicator").forEach((ind) => {
          ind.classList.remove("rotate-45");
        });

        if (!isOpen) {
          pane.style.maxHeight = pane.scrollHeight + "px";
          plus.textContent = "−";
          indicator.classList.add("rotate-45");
        }
      });
    });
  }

  // ==========================================
  // 8. QUANTITY AND SWATCH SELECTORS (PRODUCT DETAIL PAGES)
  // ==========================================
  function setupProductForm(formPrefix) {
    const form = document.getElementById(`product-form-${formPrefix}`);
    if (!form) return;

    const minusBtn = document.getElementById(`${formPrefix}-qty-minus`);
    const plusBtn = document.getElementById(`${formPrefix}-qty-plus`);
    const qtyInput = document.getElementById(`${formPrefix}-quantity-input`);
    const swatches = document.querySelectorAll(`.${formPrefix}-variant-swatch-btn`);
    const selectedInput = document.getElementById(`${formPrefix}-selected-variant-id`);
    const priceDisplay = document.getElementById(`${formPrefix}-variant-price-display`);

    if (minusBtn && plusBtn && qtyInput) {
      minusBtn.addEventListener("click", () => {
        let val = parseInt(qtyInput.value);
        if (val > 1) qtyInput.value = val - 1;
      });
      plusBtn.addEventListener("click", () => {
        let val = parseInt(qtyInput.value);
        qtyInput.value = val + 1;
      });
    }

    if (swatches.length > 0 && selectedInput && priceDisplay) {
      swatches.forEach((swatch) => {
        swatch.addEventListener("click", () => {
          swatches.forEach((s) => {
            s.classList.remove("bg-[#f7c035]", "text-pine-900", "border-[#f7c035]");
            s.classList.add("border-pine-900/20", "text-pine-900", "bg-transparent");
          });

          swatch.classList.remove("border-pine-900/20", "text-pine-900", "bg-transparent");
          swatch.classList.add("bg-[#f7c035]", "text-pine-900", "border-[#f7c035]");

          const variantId = swatch.getAttribute("data-variant-id");
          const price = swatch.getAttribute("data-price");
          const comparePrice = swatch.getAttribute("data-compare-price");
          const imageSrc = swatch.getAttribute("data-image-src");
          const mainImg = document.getElementById(`product-main-media-${formPrefix}`);
          const compareDisplay = document.getElementById(`${formPrefix}-variant-compare-display`);

          selectedInput.value = variantId;
          priceDisplay.textContent = price;

          if (compareDisplay) {
            if (comparePrice && comparePrice.trim() !== "") {
              compareDisplay.textContent = comparePrice;
              compareDisplay.classList.remove("hidden");
            } else {
              compareDisplay.textContent = "";
              compareDisplay.classList.add("hidden");
            }
          }

          if (imageSrc && mainImg) {
            mainImg.src = imageSrc;
          }
        });
      });
    }
  }

  // Set up forms for each product
  setupProductForm("lp"); // lemon powder
  setupProductForm("bl"); // black lemon
  setupProductForm("eo"); // essential oil
  setupProductForm("sp"); // seed powder
  setupProductForm("so"); // seed oil
  setupProductForm("jp"); // juice powder

  // ==========================================
  // 9. DYNAMIC PRODUCT GALLERY THUMBNAIL CLICK
  // ==========================================
  function setupGallery(btnClass, mainImgId) {
    const thumbs = document.querySelectorAll(btnClass);
    const mainImg = document.getElementById(mainImgId);
    if (thumbs.length > 0 && mainImg) {
      thumbs.forEach((thumb) => {
        thumb.addEventListener("click", () => {
          thumbs.forEach((t) => t.classList.remove("border-emerald-600", "scale-95"));
          thumb.classList.add("border-emerald-600", "scale-95");
          mainImg.src = thumb.getAttribute("data-image-src");
        });
      });
    }
  }

  setupGallery(".product-thumb-btn-lp", "product-main-media-lp");
  setupGallery(".product-thumb-btn-bl", "product-main-media-bl");
  setupGallery(".product-thumb-btn-eo", "product-main-media-eo");
  setupGallery(".product-thumb-btn-sp", "product-main-media-sp");
  setupGallery(".product-thumb-btn-so", "product-main-media-so");
  setupGallery(".product-thumb-btn-jp", "product-main-media-jp");

  // ==========================================
  // 10. GLOBAL CART DRAWER HANDLERS
  // ==========================================
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-drawer-overlay');
  const cartBubble = document.getElementById('cart-icon-bubble');

  function openCartDrawer() {
    if (cartDrawer && cartOverlay) {
      cartDrawer.classList.remove('translate-x-full');
      cartOverlay.classList.remove('opacity-0', 'pointer-events-none');
    }
  }

  function closeCartDrawer() {
    if (cartDrawer && cartOverlay) {
      cartDrawer.classList.add('translate-x-full');
      cartOverlay.classList.add('opacity-0', 'pointer-events-none');
    }
  }

  if (cartBubble) {
    cartBubble.addEventListener('click', (e) => {
      e.preventDefault();
      openCartDrawer();
    });
  }

  if (cartOverlay) {
    cartOverlay.addEventListener('click', closeCartDrawer);
  }

  // Intercept normal add-to-cart submissions
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form.action && (form.action.includes('/cart/add') || form.getAttribute('data-type') === 'add-to-cart-form')) {
      const submitter = e.submitter;
      if (submitter && submitter.classList.contains('buy-now-btn')) {
        return; // Allow native submit to redirect directly to checkout
      }

      e.preventDefault();
      const formData = new FormData(form);

      const submitBtn = form.querySelector('[type="submit"][name="add"]') || form.querySelector('button[type="submit"]');
      const originalHtml = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = 'Adding...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(async (response) => {
        if (response.ok) {
          await refreshCartDrawer();
          openCartDrawer();
        } else {
          console.error('Failed to add to cart.');
        }
      })
      .catch((err) => {
        console.error('Error adding to cart:', err);
      })
      .finally(() => {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalHtml;
        }
      });
    }
  });

  async function refreshCartDrawer() {
    const res = await fetch('/cart?section_id=cart-drawer');
    if (res.ok) {
      const htmlText = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');
      
      const newDrawer = doc.getElementById('cart-drawer');
      const currentDrawer = document.getElementById('cart-drawer');
      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
      }

      const cartRes = await fetch('/cart.js');
      if (cartRes.ok) {
        const cartJson = await cartRes.json();
        const bubbleCount = document.getElementById('cart-item-count');
        if (bubbleCount) {
          bubbleCount.textContent = cartJson.item_count;
        }
      }

      setupCartDrawerListeners();
    }
  }

  function setupCartDrawerListeners() {
    const closeBtn = document.getElementById('close-cart-drawer');
    if (closeBtn) {
      closeBtn.addEventListener('click', closeCartDrawer);
    }

    const updateButtons = document.querySelectorAll('.update-qty-btn');
    updateButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const itemRow = btn.closest('[data-item-key]');
        if (!itemRow) return;
        const itemKey = itemRow.getAttribute('data-item-key');
        const input = itemRow.querySelector('.cart-drawer-qty-input');
        const change = parseInt(btn.getAttribute('data-change'));
        if (!input || isNaN(change)) return;

        let newQty = parseInt(input.value) + change;
        if (newQty < 1) newQty = 1;

        updateCartItemQty(itemKey, newQty);
      });
    });

    const qtyInputs = document.querySelectorAll('.cart-drawer-qty-input');
    qtyInputs.forEach(input => {
      input.addEventListener('change', () => {
        const itemRow = input.closest('[data-item-key]');
        if (!itemRow) return;
        const itemKey = itemRow.getAttribute('data-item-key');
        let newQty = parseInt(input.value);
        if (isNaN(newQty) || newQty < 1) newQty = 1;

        updateCartItemQty(itemKey, newQty);
      });
    });

    const removeButtons = document.querySelectorAll('.remove-cart-item-btn');
    removeButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const itemRow = btn.closest('[data-item-key]');
        if (!itemRow) return;
        const itemKey = itemRow.getAttribute('data-item-key');
        updateCartItemQty(itemKey, 0);
      });
    });
  }

  async function updateCartItemQty(itemKey, qty) {
    const listContainer = document.getElementById('cart-drawer-items-list');
    if (listContainer) {
      listContainer.style.opacity = '0.5';
      listContainer.style.pointerEvents = 'none';
    }

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: qty
        })
      });
      if (res.ok) {
        await refreshCartDrawer();
      }
    } catch (e) {
      console.error('Failed to update cart quantity:', e);
    } finally {
      if (listContainer) {
        listContainer.style.opacity = '1';
        listContainer.style.pointerEvents = 'auto';
      }
    }
  }

  setupCartDrawerListeners();

});
